import omit from "lodash/omit";
import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { PostContent } from "PFApp/components/card_tx/content/post_content";
import { PostHeader } from "PFApp/components/card_tx/header/post_header";
import { Status } from "PFApp/components/card_tx/status/status";

export type PostVariantProps = Pick<
  CardTxContentProps,
  | "activity"
  | "type"
  | "isFeed"
  | "isDraft"
  | "handleShare"
  | "handleEditPost"
  | "handleHeaderClick"
  | "handleRefetchActivities"
>;

export const PostVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  handleShare,
  handleEditPost,
  handleHeaderClick,
  handleRefetchActivities
}: PostVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    activity,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <PostHeader
        {...omit(commonHeaderProps, ["type"])}
        handleEditPost={handleEditPost}
        handleHeaderClick={handleHeaderClick}
      />
      <Status isPrivate={activity.private} isDraft={isDraft} />
      <PostContent activity={activity} />
    </>
  );
};
